import { AppContext } from 'state/context'
import { useContextSelector } from 'use-context-selector'

import { createUserSelectorCallback } from 'utils/createUserSelectorCallback'

export const useProjectCoordinators = () => {
  return useContextSelector(
    AppContext,
    createUserSelectorCallback('projects', 'projectCoordinators'),
  )
}
